import { render, staticRenderFns } from "./BaseConfig.vue?vue&type=template&id=8dc0ddca&scoped=true&"
import script from "./BaseConfig.vue?vue&type=script&lang=js&"
export * from "./BaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfig.vue?vue&type=style&index=0&id=8dc0ddca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc0ddca",
  null
  
)

export default component.exports